import { render } from "./TransactionDetailsComponent.vue?vue&type=template&id=4555b228&scoped=true&ts=true"
import script from "./TransactionDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./TransactionDetailsComponent.vue?vue&type=script&lang=ts"

import "./TransactionDetailsComponent.vue?vue&type=style&index=0&id=4555b228&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4555b228"],['__file',"src/components/transaction/TransactionDetailsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4555b228"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4555b228', __exports__)) {
    api.reload('4555b228', __exports__)
  }
  
  module.hot.accept("./TransactionDetailsComponent.vue?vue&type=template&id=4555b228&scoped=true&ts=true", () => {
    api.rerender('4555b228', render)
  })

}


export default __exports__